export type ReadStopwatch = () => number;

/**
 * Create a stopwatch function that returns the time elapsed since the stopwatch was created.
 * @returns A function that returns the time elapsed since the stopwatch was created.
 * @example
 * const stopwatch = startStopwatch();
 * // ... do something ...
 * const elapsed = stopwatch();
 */
export function startStopwatch(): ReadStopwatch {
    const start = Date.now();
    return () => {
        const end = Date.now();
        return end - start;
    };
}
